<mat-progress-bar
  [style.visibility]="loading ? 'visible' : 'hidden'"
  mode="indeterminate"
>
</mat-progress-bar>
<form [formGroup]="form" (submit)="submit(form.value)">
  <mat-form-field>
    <input
      matInput
      type="email"
      formControlName="email"
      placeholder="Email Address"
    />

    <mat-error *ngIf="email.hasError('email') && !email.hasError('required')">
      Email is <strong>invalid</strong>
    </mat-error>
    <mat-error *ngIf="email.hasError('required')">
      Email is <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-hint>{{ "invite.externalIdDescription" | translate }}</mat-hint>
    <input
      matInput
      type="string"
      autocapitalize="off"
      autocomplete="off"
      formControlName="externalId"
      placeholder="ID (optional)"
    />
  </mat-form-field>
  <br />

  <ca-role-select
    placeholder="Role"
    formControlName="role"
    [options]="roleOptions"
  ></ca-role-select>

  <ng-container
    *ngIf="form.get('role').value === CARER"
    formGroupName="qualifications"
  >
    <mat-slide-toggle formControlName="accessAllCustomers">{{
      "staff.accessAllCustomers" + form.get("role").value | translate
    }}</mat-slide-toggle>
    <p
      *ngIf="
        !!form.get('qualifications').get('accessAllCustomers').value;
        else assignedCustomersWarning
      "
    >
      {{
        "staff.accessAllCustomersEnabled" + form.get("role").value | translate
      }}
    </p>
    <ng-template #assignedCustomersWarning>
      <p>
        {{
          "staff.accessAllCustomersDisabled" + form.get("role").value
            | translate
        }}
      </p>
    </ng-template>

    <div
      *ngIf="
        form.get('role').value === CARER &&
        !form.get('qualifications').get('accessAllCustomers').value
      "
    >
      <div class="row">
        <ca-avatar-stack
          [size]="'small'"
          item-start
          [maxAvatars]="MAX_AVATAR_COUNT"
          [avatars]="customers$ | async | avatars | async"
        ></ca-avatar-stack>
        <ca-select-trigger
          icon="add"
          [label]="
            (customers$ | async)
              ? (customers$
                | async
                | customerselection : ('customerDetail.title' | translate))
              : ('newMemo.selectCustomerLabel' | translate)
          "
          (select)="openCustomerSelection()"
        >
        </ca-select-trigger>
      </div>
      <mat-error
        *ngIf="
          form.get('role').value === CARER &&
          !form.get('qualifications').get('accessAllCustomers').value &&
          customerIdsControl.hasError('required')
        "
      >
        {{ "invite.errors.selectCustomers" | translate }}
      </mat-error>
    </div>
  </ng-container>

  <button mat-flat-button [disabled]="disabled" color="primary" type="submit">
    Send Invitation
  </button>
  <mat-error *ngIf="error"> Failed to send invitation. </mat-error>
</form>
